import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db240c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lead-time-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Lead Time Embarque Criado x Faturado", -1))
const _hoisted_3 = { class: "card-subtitle" }
const _hoisted_4 = {
  key: 1,
  class: "lead-time-footer"
}
const _hoisted_5 = { class: "lead-time-footer-item-off-target" }
const _hoisted_6 = { class: "lead-time-text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Fora da meta ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "lead-time-footer-item-within-target" }
const _hoisted_12 = { class: "lead-time-text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Dentro da meta ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "(Meta " + _toDisplayString(_ctx.leadTimeTarget) + " dias)", 1),
    _createVNode(_component_VChart, {
      class: _normalizeClass([{ loadingClass: _ctx.loading }, "chart"]),
      ref: "chart",
      option: _ctx.options,
      autoresize: ""
    }, null, 8, ["class", "option"]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, [
                _hoisted_7,
                _hoisted_8,
                (_ctx.ordersOffTarget > 1)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_9, _toDisplayString(_ctx.ordersOffTarget) + " pedidos", 1))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.ordersOffTarget) + " pedido", 1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, [
                _hoisted_13,
                _hoisted_14,
                (_ctx.ordersWithinTarget > 1)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_15, _toDisplayString(_ctx.ordersWithinTarget) + " pedidos", 1))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_16, _toDisplayString(_ctx.ordersWithinTarget) + " pedido", 1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}